import {Pipe, PipeTransform} from '@angular/core';
import {DadoTransacional} from '../../modelos/dado-transacional';

@Pipe({
  name: 'filtroDadosTransacionais'
})
export class FiltroDadosTransacionaisPipe implements PipeTransform {

  transform(dadosTransacionais: DadoTransacional[], filtro?: string): any {
    if (dadosTransacionais === undefined || filtro === undefined || filtro.trim() === '') {
      return dadosTransacionais;
    }
    filtro = filtro.toLocaleLowerCase();
    return dadosTransacionais.filter(dadoTransacional => dadoTransacional.nomeDadoTransacional.toLocaleLowerCase().indexOf(filtro) >= 0);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/filtros/pipes/filtro-dados-transacionais.pipe.ts